import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map-arrow",
  "use": "map-arrow-usage",
  "viewBox": "0 0 21 9",
  "content": "<symbol viewBox=\"0 0 21 9\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"map-arrow\">\n<path d=\"M0.5 0H20.5C17.8937 0.977362 15.6416 2.71604 14.0364 4.99009L11.9084 8.00471C11.2216 8.97777 9.77842 8.97777 9.09156 8.00471L6.96359 4.99009C5.35838 2.71604 3.1063 0.977362 0.5 0Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol